module.exports = __webpack_public_path__ + "public/img/baoxiuzongshu.b614a465.png";